/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * @hidden
 */
var AccessTokenCacheItem =
/** @class */
function () {
  function AccessTokenCacheItem(key, value) {
    this.key = key;
    this.value = value;
  }

  return AccessTokenCacheItem;
}();

export { AccessTokenCacheItem };